// Configuración global de la aplicación

// URL de la API - configurada por variable de entorno
export const API_BASE_URL =
  process.env.REACT_APP_BACKEND_URL || "https://api.visualmaxplr.q2bstudio.com/api";
